import * as React from 'react';
import { useEffect } from 'react';

import { useTracker } from '@coursera/event-pulse/react';

import EventingContext from 'bundles/unified-career-academy/contexts/EventingContext';

const EventingDataProvider = ({ roleSlug, children }: { roleSlug: string; children: React.ReactNode }) => {
  const track = useTracker();

  useEffect(() => {
    track('view_role_page', {
      role: {
        roleSlug,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleSlug]);

  return (
    <EventingContext.Provider
      value={{
        role: {
          roleSlug,
        },
      }}
    >
      {children}
    </EventingContext.Provider>
  );
};

export default EventingDataProvider;
